export const LOAD_ITEMS = 'LOAD_ITEMS'
export const ADD_ITEM = 'ADD_ITEM'